import HGLink from '../index'
import { LinkProps } from '../links.types'

export function LinkArticleDetail({
  children,
  slug,
  ...props
}: LinkProps & { slug: string }) {
  return (
    <HGLink
      href={getArticleDetailHref(slug)}
      aria-label='go to blog detail'
      {...props}
    >
      {children}
    </HGLink>
  )
}

export function getArticleDetailHref(slug: string) {
  return `/blog/${slug}`
}
